import { PlayerEnvironment } from "./player_environment";
import i18n from "./utils/i18n";
import createElement from "@javascripts/utils/create_element";

export default class ChromeVersionBlocker {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
  }

  shouldInit() {
    return this.data().drmEnabled() && PlayerEnvironment.isNotSupportedChromeVersion();
  }

  init() {
    this.showBlocker();

    this.tech().one('playing', () => this.tech().pause());
  }

  showBlocker() {
    this.tech().pause();
    
    const element = createElement(`
      <div class="vjs-player-error__section">
        <div class="vjs-player-error__container">
          <div class="vjs-player-error__header">
            <h3 class="vjs-player-error__title-revamp">${i18n('blocker.chrome_version.title')}</h3>
            <div class="vjs-player-error__subtitle-revamp">${i18n('blocker.chrome_version.subtitle')}</div>
          </div>
        </div>
      </div>
    `);

    const container = element.querySelector('.vjs-player-error__container');

    container.appendChild(this.closeButton())

    this.tech().el().el().appendChild(element);
  }

  closeButton() {
    let element = document.createElement('button');
    element.className = 'vjs-player-error__close-btn';
    element.innerHTML = '&times;';
    element.onclick = this.onCloseButtonClick;
    return element;
  }

  onCloseButtonClick() {
    const blockerElement = document.querySelector('.vjs-player-error__section');

    blockerElement.parentNode.removeChild(blockerElement);
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }
}
